export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig();
    const siteKey = config.public.googleRecaptchaSiteKey;

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=explicit`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    return {
        provide: {
            recaptchaSiteKey: siteKey,
        },
    };
});
